import React from "react";
import { Col, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";

function ManualTransferRemark({  }) {

    return (
        <div className="mt-4 note-disclaimer-container">
            <div className="p-3 p-lg-4 pt-3 tnc-content disable-scroll">
                <div className="text-bold-600">*Notes:</div>
                <Col md={6}>
                    <p className="text-bold-600 my-2 p-0">Remark:</p>
                    <div className="tnc-table-content">
                        <p className="text-bold-600">Type of payment</p>
                        <div className="d-flex special-border-tnc">
                            <p>Cash</p>
                            <p>Cash Deposit Machine (CDM)/ Over the bank counter</p>
                        </div>
                        <div className="d-flex special-border-tnc">
                            <p>Direct Transfer</p>
                            <p>ATM/ Interbank Giro(IBG)/ Online Transfer/ TT</p>
                        </div>
                        <p className="alert-text">*No Third Party Payment is allowed</p>
                    </div>
                </Col>
                <br/>
                <div className="tnc-bottom-remark">
                    <p>
                        * Clients are discouraged from making cash deposit via Cash Deposit Machine (CDM).
                    </p>
                    <p>
                        * Bank in slip with client signature is required for cash payment via CDM or Over the Counter
                        (OTC).
                    </p>
                    <p>
                        * Cumulative cash deposits exceeding <span className="text-bold-600">RM25k</span> for past 1 year
                        requires our management approval and may take longer time to process.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ManualTransferRemark;
